function noop() { }
export const defaultProps = {
    prefixCls: 'am-search',
    placeholder: '',
    onSubmit: noop,
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onClear: noop,
    showCancelButton: false,
    disabled: false,
};



// WEBPACK FOOTER //
// ./components/search-bar/PropsType.tsx